import { useQuery } from '@tanstack/react-query';
import { get } from 'api/base';
import type { BillingScheinStatus } from 'types/billingScheinStatus';

export function useBillingScheinStatus(medatixxId?: string | null) {
  return useQuery<BillingScheinStatus>({
    queryKey: ['billingScheinStatus', medatixxId],
    queryFn: () =>
      get('scheinStatus', undefined, {
        medatixxId,
      }) as Promise<BillingScheinStatus>,
    enabled: !!medatixxId,
  });
}
